import React from "react";
import LeftTurnSvg from "./left-turn.svg";

interface LeftTurnArrowProps {
    rotation?: number;
    count?: number;
    size?: number;
}

export const LeftTurnArrow: React.FC<LeftTurnArrowProps> = ({ rotation = 0, count, size = 60 }) => {
    return (
        <g transform={`rotate(${rotation})`}>
            <image href={LeftTurnSvg} width={size} height={size} x={-size / 2} y={-size / 2} />
        </g>
    );
};
